// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"50c412ffbb468348a4ef","293":"ecc9b6d44d61b097767c","518":"1b78b3ee1b3207f03b0f","779":"ff8b1cfbf7d213060a04"}[chunkId] + ".js";
};